<template>

  <v-toolbar
    flat
    height="55"
    class="mt-5 pa-0 white--text sfh-login-header border-radius-0"
  >
    &copy; Copyright {{ new Date().getFullYear() }}, Cogneti LLC
    <v-spacer></v-spacer>
    <img class="pr-2 mt-1" src="static/images/ansi-blue-inverse.png" alt="ANSI" height="40"/>
  </v-toolbar>

</template>

<script>
export default {
  name: 'app-footer',
  data () {
    return {
    }
  }
}
</script>

<style scoped>
  .border-radius-0{
    border-radius: 0!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/Footer.vue